module.exports = __webpack_public_path__ + "static/media/IMG-5.f5c8cc4b.jpg";